import { useState } from 'react'
import { Link } from 'react-router-dom'
import { api } from '../lib/api'
import { toast } from '../lib/toast'
import Button from '../components/ui/Button'
import Input from '../components/ui/Input'

export default function ForgotPassword() {
  const [email, setEmail] = useState('')
  const [busy, setBusy] = useState(false)
  const [done, setDone] = useState(false)

  async function submit(e: React.FormEvent) {
    e.preventDefault()
    setBusy(true)
    try {
      await api('/api/auth/forgot-password', {
        method: 'POST',
        body: JSON.stringify({ email }),
      })
      setDone(true)
    } catch (err) {
      toast.error((err as Error).message)
    } finally {
      setBusy(false)
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center px-4">
      <div className="w-full max-w-sm space-y-4">
        <h1 className="text-2xl font-semibold">Şifre sıfırlama</h1>
        {done ? (
          <p className="text-sm text-[var(--color-text-muted)]">
            Eğer bu email kayıtlıysa, sıfırlama linki gönderildi. Email'ini kontrol et.
          </p>
        ) : (
          <form onSubmit={submit} className="space-y-3">
            <Input
              type="email"
              placeholder="email@example.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <Button type="submit" disabled={busy} variant="primary">
              {busy ? 'Gönderiliyor...' : 'Sıfırlama linki gönder'}
            </Button>
          </form>
        )}
        <Link to="/login" className="text-sm text-[var(--color-text-muted)] hover:underline">
          ← Giriş'e dön
        </Link>
      </div>
    </div>
  )
}
